import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import HeaderMobile from '../Component/MobileHader'
import { Hourglass } from 'react-loader-spinner'

const Services = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Set loading to false after a 2-second delay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    // Cleanup timer to avoid memory leaks
    return () => clearTimeout(timer);
  }, []);
  return (
    <React.Fragment>
          {loading ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100vh",
                            }}
                          >
                            <Hourglass
                              height={80}
                              width={80}
                              color="#01458e"
                              ariaLabel="loading-content"
                            />
                          </div>
                        ) : (
      <div>
      <HeaderMobile/>
        <Container>
            <div className='galleryRow  '>
            <h5 className='serviceTitle'>
            SERVICES
            </h5>
            <p>
            Griphold provides Repairs and Servicing facilities to its customers for the following equipments:
            </p>
            <ol>
                <li>
                Hydraulic, Electric, Pneumatic and Mechanical Torque Wrenches;
                </li>
                <li>
                Hydraulic cylinders / Jacks and pumps
                </li>
                <li>
                Hydraulic Flange spreaders
                </li>
                <li>
                Hydraulic Bolt Tensioning Devices
                </li>
                <li>
                Hydraulic Nut Splitters
                </li>
                <li>
                Hydraulic Pullers
                </li>
                <li>
                Other hydraulic equipments.
                </li>
            </ol>
            <div className='serviceRequestDiv'>
                <Link className='serviceRequestLink' to="#">
                Service Request
                </Link>
            </div>
            </div>
        </Container>
        </div>
            )}
    </React.Fragment>
  )
}

export default Services